  import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@flaticon/flaticon-uicons/css/regular/rounded.css';
import '@flaticon/flaticon-uicons/css/solid/rounded.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/native-app.css';
import './styles/mobile-redesign.css';
import { initNativeApp } from './shared/native/nativeApp';

void initNativeApp();

// Auto-reload on chunk load failure (stale deployment cache)
window.addEventListener('error', (event) => {
  const msg = event.message || '';
  if (msg.includes('ChunkLoadError') || msg.includes('Loading chunk')) {
    const reloadKey = 'chunk_reload_ts';
    const lastReload = Number(sessionStorage.getItem(reloadKey) || 0);
    // Only reload once per 30 seconds to avoid infinite loops
    if (Date.now() - lastReload > 30000) {
      sessionStorage.setItem(reloadKey, String(Date.now()));
      window.location.reload();
    }
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  if (reason?.name === 'ChunkLoadError' || String(reason).includes('Loading chunk')) {
    const reloadKey = 'chunk_reload_ts';
    const lastReload = Number(sessionStorage.getItem(reloadKey) || 0);
    if (Date.now() - lastReload > 30000) {
      sessionStorage.setItem(reloadKey, String(Date.now()));
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

(window as any).__REACT_APP_MOUNTED__ = true;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
